class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = document.querySelector("[data-header]");
    this.headerWrapper = document.querySelector("#shopify-section-header");
    this.stickyHeader = document.querySelector("sticky-header");

    const accountIconLink = document.querySelector('[data-account-icon-link]');
    const accountLinkMobileMenu = document.querySelector('[data-account-link-mobile-menu]');

    if (this.header) {
      this.shadow = document.querySelector(".header-shadow");
      this.menu = this.header.querySelector(".header__menu");
      this.shadow?.addEventListener("click", () => {
        this.closeAll();
      });
    }

    if (accountIconLink) {
      accountIconLink.addEventListener("click", () => {
        if(window.screen.width >= 768) {
        localStorage.setItem("currentAccountContent", "account-details");
        } else {
          localStorage.setItem("currentAccountContent", "");
        }
      });
    }

    if (accountLinkMobileMenu) {
      accountLinkMobileMenu.addEventListener("click", () => {
        localStorage.setItem("currentAccountContent", "");
      });
    }
  }

  open(group) {
    super.open(group);
    if (this.headerWrapper) {
      // open header
      this.headerWrapper.classList.add("shopify-section-header--open");
      document.querySelector("body").classList.add("header--is-open");
      // close search
      this.header.classList.remove("header__search--is-active");
      document.body.classList.remove("search--is-active");
    }
    this.stickyHeader?.makeOpaque("menu");
    this.menu?.classList.add("header__menu--is-open");
  }

  close(group) {
    super.close(group);

    // Only close header if all groups are closed
    let anyOpen = false;
    this.groups.forEach((group) => {
      if (group.classList.contains(this.options.toggleClass)) {
        anyOpen = true;
      }
    });

    if (!anyOpen) {
      this.headerWrapper?.classList.remove("shopify-section-header--open");
      document.querySelector("body").classList.remove("header--is-open");
      this.stickyHeader?.makeTransparent("menu");
      this.menu?.classList.remove("header__menu--is-open");
    }
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    // Header state is managed by close()
  }

  openAll() {
    super.openAll();
    this.stickyHeader?.makeOpaque("menu");
    this.menu?.classList.add("header__menu--is-open");
  }

  closeAll() {
    super.closeAll();
    this.stickyHeader?.makeTransparent("menu");
    this.menu?.classList.remove("header__menu--is-open");
  }
}

class CollapsibleMenu extends Collapsible {
  constructor() {
    super();
    this.backBtns = this.querySelectorAll('[data-collapsible-back]');
    this.backBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        var currentGroup = btn.closest('[data-collapsible-group]');
        var currentTarget = btn.closest('[data-collapsible-target]');
        console.log('currentGroup', currentGroup);
        if (currentTarget) {
          currentTarget.classList.add('menu-drawer__submenu--close');
        }
        if (currentGroup) {
          setTimeout(() => {
            currentGroup.classList.remove('menu-drawer__menu-item--is-open');
            currentTarget.classList.remove('menu-drawer__submenu--close');
          }, 200);
        }
      });
    });
  }

}


class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();
    this.header = this.closest("[data-header]");
    this.headerWrapper = this.closest("#shopify-section-header");
    this.stickyHeader = document.querySelector("sticky-header");

    if (this.header) {
      this.shadow = document.querySelector(".header-shadow");

      document.addEventListener("keyup", this.onKeyUp.bind(this));
      this.shadow?.addEventListener("click", this.remove.bind(this));
    }
  }

  onKeyUp(event) {
    if (!this.header.classList.contains("header--is-open")) return;
    if (event?.code.toUpperCase() !== "ESCAPE") return;

    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();

    // Hide menu text when menu is opened
    if (this.querySelector(".menu-drawer__menu-text")) {
      this.querySelector(".menu-drawer__menu-text").style.display = "none";
    }

    this.stickyHeader?.makeOpaque("mobile-menu");
    this.header?.classList.add("header--is-open");
    this.headerWrapper?.classList.add("shopify-section-header--open");

    if (this.options.ariaExpanded) {
      document.body.classList.add("menu-drawer--is-open");
      document
        .querySelectorAll("toggle-mobile-navigation")
        .forEach((button) => button.setAttribute("aria-expanded", true));
    }

    trapFocus(this.header);
  }

  remove() {
    super.remove();

    // Show menu text when menu is closed
    if (this.querySelector(".menu-drawer__menu-text")) {
      this.querySelector(".menu-drawer__menu-text").style.display = "block";
    }

    this.stickyHeader?.makeTransparent("mobile-menu");
    this.header?.classList.remove("header--is-open");
    this.headerWrapper?.classList.remove("shopify-section-header--open");

    if (this.options.ariaExpanded) {
      document.body.classList.remove("menu-drawer--is-open");
      document
        .querySelectorAll("toggle-mobile-navigation")
        .forEach((button) => button.setAttribute("aria-expanded", false));
    }

    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector("collapsible-element");
    collapsibles?.closeAll();
  }
}

class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = document.querySelector("[data-header]");
    this.shadow = document.querySelector(".header-shadow");
    this.header = document.querySelector("[data-header]");
    this.headerWrapper = document.querySelector("#shopify-section-header");
    this.menuDrawer = document.querySelector("[data-menu-drawer]");

    this.shadow?.addEventListener("click", () => {
      this.header.classList.remove("header__search--is-active");
      document.body.classList.remove("search--is-active");
    });

    // options
    this.searchInputDesktop = this.target?.querySelector(
      "#desktopSearchInModal"
    );
    this.searchInputMobile = this.target?.querySelector("#mobileSearchInModal");

    // Add focus/blur handlers for mobile search
    this.searchInputMobile?.addEventListener("focus", () => {
      this.header.classList.add("header__search--is-active");
      this.searchInputMobileParent = this.searchInputMobile.closest("search-modal__form");

      if (this.searchCloseBtn) {
        this.searchCloseBtn.classList.remove("hidden");
      }
      this.headerWrapper.classList.remove("shopify-section-header--open");
      this.header.classList.remove("header--is-open");
      this.menuDrawer.classList.remove("menu-drawer--is-active");
    });

    // key up escape
    document.addEventListener("keyup", (event) => {
      this.onKeyUp(event);
    });

    // Remove classes incase the header navigation drawer is open.
    this.addEventListener("click", () => {
      document.body.classList.remove("header-is-open");
      document.body.classList.remove("menu-drawer--is-open");
      this.header.classList.remove("header--is-open");
      this.header.classList.toggle("header__search--is-active");
      document.body.classList.toggle("search--is-active");
      document
        .querySelector(".menu-drawer")
        .classList.remove("menu-drawer--is-active");
      // Focus on input element if provided
      if (this.options.focusTarget) {
        document.querySelector(this.options.focusTarget)?.focus();
      }
    });
  }

  onKeyUp(event) {
    if (!this.header.classList.contains("header__search--is-active")) {
      document.body.classList.remove("header-is-open");
      document.body.classList.remove("menu-drawer--is-open");
      this.header.classList.remove("header--is-open");
      return;
    }
    if (event?.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    this.searchInputDesktop?.focus();
    this.searchInputMobile?.focus();
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    removeTrapFocus();
  }
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // Cache DOM elements
    this.header = document.querySelector("[data-header]");
    this.headerWrapper = document.querySelector("#shopify-section-header");
    this.announcementBar = document.querySelector(
      "#shopify-section-announcement-bar"
    );
    this.announcementSlider = document.querySelector(
      "#shopify-section-announcements-slider"
    );

    if (!this.headerWrapper) return;

    // State tracking
    this.isTransparent = this.header.classList.contains("header--transparent");
    this.isIndex = document.body.classList.contains("template-index");
    this.isChildOpen = false;
    this.openChildren = new Set(); // Track which children are open
    this.lastScrollY = window.scrollY;
    this.scrollOffset = 0;
    this.headerStart = 0;
    this.ticking = false;

    // Calculate initial offsets
    this.calculateOffsets();

    // Bind methods
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);

    // Initialize
    this.updateHeaderHeight();
    this.addScrollListener();

    // Update header height every second as a fallback
    this.heightInterval = setInterval(() => this.updateHeaderHeight(), 1000);
  }

  calculateOffsets() {
    if (this.header) {
      this.scrollOffset += this.header.offsetHeight;
    }

    if (this.announcementBar) {
      const height = this.announcementBar.offsetHeight;
      this.scrollOffset += height;
      this.headerStart += height;
    }

    if (this.announcementSlider) {
      const height = this.announcementSlider.offsetHeight;
      this.scrollOffset += height;
      this.headerStart += height;
    }
  }

  addScrollListener() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  removeScrollListener() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    this.currentScrollY = window.scrollY;

    // Request animation frame only if we're not already updating
    if (!this.ticking) {
      requestAnimationFrame(this.update);
      this.ticking = true;
    }
  }

  update() {
    this.ticking = false;

    if (Math.abs(this.currentScrollY - this.lastScrollY) < 5) return;

    const scrollTop = this.currentScrollY;
    const isScrollDown = scrollTop > this.lastScrollY;
    const isAtBottom =
      scrollTop + window.innerHeight >= document.body.clientHeight;
    const isAboveHeader = scrollTop <= this.headerStart;
    const isPastOffset = scrollTop > this.scrollOffset;

    if (isAtBottom || (isScrollDown && isPastOffset)) {
      this.hide();
    } else if (isAboveHeader) {
      this.revealTop();
    } else if (!isScrollDown && !isAboveHeader) {
      this.reveal();
    }

    this.lastScrollY = scrollTop;
  }

  disconnectedCallback() {
    this.removeScrollListener();
  }

  updateHeaderHeight() {
    let totalHeight = this.header?.offsetHeight || 0;

    document.documentElement.style.setProperty(
      "--header-height",
      `${totalHeight}px`
    );
    document.documentElement.style.setProperty(
      "--header-height-announcement",
      `${
        totalHeight +
        this.announcementBar?.offsetHeight +
        this.announcementSlider?.offsetHeight
      }px`
    );
  }

  hide() {
    this.makeOpaque();
    if (this.isOpen) {
      document.body.classList.remove("header--is-open");
      this.header.classList.remove("header--is-open");
      this.isOpen = false;
    }

    if (!this.isSticky) {
      // this.headerWrapper.classList.add("shopify-section-header--sticky");
      this.isSticky = true;
    }

    this.headerWrapper.classList.remove("shopify-section-header--open");
    this.closeHeaderNav();
    this.closeMobileNav();
    this.closeSearch();
    this.productInfoPosition("up");
    this.updateHeaderHeight();
  }

  reveal() {
    this.makeOpaque();

    const stickyClass = "shopify-section-header--sticky";
    const animateClass = "shopify-section-header--animate";

    if (!this.headerWrapper.classList.contains(stickyClass)) {
      // this.headerWrapper.classList.add(stickyClass);
      this.isSticky = true;
    }

    if (!this.headerWrapper.classList.contains(animateClass)) {
      this.headerWrapper.classList.add(animateClass);
      this.isAnimating = true;
    }

    this.productInfoPosition("down");
    this.updateHeaderHeight();
  }

  revealTop() {
    if (!this.isChildOpen) this.makeTransparent();

    if (this.isSticky || this.isAnimating) {
      this.headerWrapper.classList.remove(
        "shopify-section-header--sticky",
        "shopify-section-header--animate"
      );
      this.isSticky = false;
      this.isAnimating = false;
    }

    document.body.classList.remove("sticky");
    this.productInfoPosition("up");
    this.updateHeaderHeight();
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if (!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains("header__search--is-active")) {
      this.header?.classList.remove("header__search--is-active");
      this.searchToggle.remove();
      document.body.classList.remove("search--is-active");
    }
  }

  productInfoPosition(pos = "up") {

  }

  initMobileAccountLinks() {
    if (window.screen.width >= 768) return;

    const accountLinks = document.querySelectorAll('[href*="/account"]');
    accountLinks?.forEach((link) => {
      link.addEventListener("click", () => {
        localStorage.setItem("currentAccountContent", "");
      });
    });
  }

  // Helper method to safely toggle classes
  toggleClasses(element, classes, force) {
    if (!element) return;

    if (Array.isArray(classes)) {
      classes.forEach((className) => {
        const hasClass = element.classList.contains(className);
        if (force && !hasClass) {
          element.classList.add(className);
        } else if (!force && hasClass) {
          element.classList.remove(className);
        }
      });
    } else {
      const hasClass = element.classList.contains(classes);
      if (force && !hasClass) {
        element.classList.add(classes);
      } else if (!force && hasClass) {
        element.classList.remove(classes);
      }
    }
  }

  // Public API for child components
  makeOpaque(childId = null) {
    if (!this.header) return;

    if (childId) {
      this.openChildren.add(childId);
    }
    this.isChildOpen = this.openChildren.size > 0;

    this.header.classList.remove("header--transparent");
    this.header.classList.add("header--inverse-solid");
  }

  makeTransparent(childId = null) {
    if (!this.classList.contains("header--can-become-transparent"))
      return;
    if (!this.header) return;
    if (childId) this.openChildren.delete(childId);

    this.isChildOpen = this.openChildren.size > 0;

    // Allow transparency if no children are open, we're at the top, and search is not active
    if (
      !this.isChildOpen &&
      window.scrollY <= this.headerStart &&
      !this.header.classList.contains("header__search--is-active")
    ) {
      this.header.classList.add("header--transparent");
      this.header.classList.remove("header--inverse-solid");
    }
  }

  setTextColor(isInverse) {
    if (!this.header) return;

    if (isInverse) {
      this.header.classList.add("header--inverse");
    } else {
      this.header.classList.remove("header--inverse");
    }
  }
}

if (!customElements.get("collapsible-header")) {
  customElements.define("collapsible-header", CollapsibleHeader);
}

if (!customElements.get("collapsible-menu")) {
  customElements.define("collapsible-menu", CollapsibleMenu);
}

if (!customElements.get("toggle-mobile-navigation")) {
  customElements.define("toggle-mobile-navigation", ToggleMobileNavigation);
}

if (!customElements.get("toggle-search")) {
  customElements.define("toggle-search", ToggleSearch);
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
